module.exports = __webpack_public_path__ + "static/media/ottawa-9.0e72f8cd.jpg";